<!DOCTYPE html>
<html lang="en">
  <head>
    <!-- Required meta tags -->
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1" />
    <title>NorsupOne</title>
  </head>
  <body>
    <div class="container-fluid">
      <div class="row gx-0">
        <div class="col-lg-12">
          <div class="side-menu">
            <app-side-bar></app-side-bar>
          </div>
          <div class="right-side">
            <div class="pt-3">
              <div class="glass-bg w-100 profile-card-block">
                <div class="profile-card px-3 text-center">
                  <div class="user-avatar pb-3 edit-avatar">
                    <img *ngIf="!this.editedProfileImage"
                      [src]="profileImage" />
                    <img *ngIf="this.editedProfileImage"
                      [src]="preview" />
                    <label for="fileInput" class="edit-ico">
                      <img src="assets/img/edit-avatar.svg" alt="Edit Avatar">
                      <input type="file" id="fileInput"
                        (change)="onFileSelected($event)"
                        accept="image/png, image/gif, image/jpeg, image/tiff, image/webp">
                    </label>
                  </div>

                  <form
                    [formGroup]="editProfileForm"
                    (ngSubmit)="onSubmit()"
                    class="px-2 profile-edit">
                    <div class="mb-3">
                      <label for="exampleFormControlInput1"
                        class="form-label">First name</label>
                      <input type="text" class="form-control"
                        id="exampleFormControlInput1"
                        placeholder="{{firstName}}"
                        class="form-control"
                        formControlName="editedFirstName"
                        name="editedFirstName"
                        [value]="firstName">
                    </div>

                    <div class="mb-3">
                      <label for="exampleFormControlInput1"
                        class="form-label">Last name</label>
                      <input type="text" class="form-control"
                        id="exampleFormControlInput1"
                        placeholder="{{lastName}}"
                        class="form-control"
                        formControlName="editedLastName"
                        name="editedLastName"
                        [value]="lastName">
                    </div>
                    <span class="alert-message"
                      *ngIf="errorString">{{errorString}}</span>
                      <span *ngIf="editedFirstName?.errors?.['maxlength'] && !errorString" class="alert-message">
                        First name cannot exceed 10 characters.
                      </span>
                      <span *ngIf="editedLastName?.errors?.['maxlength'] && !errorString" class="alert-message">
                        First name cannot exceed 10 characters.
                      </span>
                    <div class="d-grid gap-2 pt-2">
                      <button class="btn btn-primary"
                        type="button" (click)="onSubmit()">Save</button>
                    </div>

                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </body>
</html>
